import React, { PropTypes } from 'react';
import langMap from '../langMap';

const SectionHeader = ({ lang, title }) => (
  <header className="fold__col__header">
    {
      lang === 'ar' ?
        <h1 className="fold__col__title">{langMap[title].arabic}</h1> :
        <h1 className="fold__col__title">
          <span className="fold__col__title__initial">{langMap[title].initial}</span>
          <span className="fold__col__title__rest">{langMap[title].rest}</span>
        </h1>
    }
  </header>
  );

export default SectionHeader;

SectionHeader.propTypes = {
  lang: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./js/components/SectionHeader.js